export default __webpack_public_path__ + "static/media/trustpilot.3e8d9068.svg";